import { EmailInputView } from './EmailInputView.js'
import { Layout } from '../components/layout/Layout.js'
import { Header } from '../components/Header.js'

export class InvitationEmailView extends EmailInputView {
    renderLayout() {
        const { mainText = '', subText = '' } = this.$props
        this.$props.Layout = new Layout(this.$target, {
            isAppend: true,
            sectionId: `emailInputSection`,
            mainText,
            subText,
            nextButton: {
                text: this.getNextButtonText(),
                nextPageFunc: this.moveEmailAuthView.bind(this),
            },
        })
    }

    renderComponents() {
        super.renderComponents()

        new Header(this.$props.Layout.getHeaderLayer(), {
            isShowLoginBtn: true,
            isShowPrevBtn: false,
        })
    }
}